import { ref, Ref } from 'vue'
import errorMsg from 'chain33errori18n'
import { ElNotification } from 'element-plus'
import Rpc from '@/config/apiServer/chain33rpc'

interface ToolMixins {
  result: Ref<any>,
  isDisabled: Ref<boolean>,
  submit: (type: string, msg: string) => Promise<void>
}
type DataType = {
  error: null | string,
  id: number,
  result: {
    [propName: string]: any;
  }
}

export default (): ToolMixins => {
  const result = ref()
  const isDisabled = ref<boolean>(false)
  // 处理数据
  function dealMsg(data: DataType): void {
    if (data.error == null) {
      result.value = data.result
      ElNotification({
        title: "提示",
        message: "成功",
        type: "success",
        duration: 1500
      })
    } else {
      result.value = ''
      ElNotification({
        title: "提示",
        message: errorMsg(data.error),
        type: "warning",
        duration: 1500
      })
    }
  }
  // 提交解析/广播
  async function submit(msg: string, type: string): Promise<void> {
    if (isDisabled.value) return
    isDisabled.value = true
    let str = msg.trim()
    if (!str) {
      ElNotification({
        title: '提示',
        message: "数据文本不能为空",
        type: 'warning'
      })
      isDisabled.value = false
      return
    }
    str = str.slice(0, 2) === '0x' ? str.slice(2, str.length) : str
    if (!/^[0-9a-fA-F]+$/.test(str)) {
      ElNotification({
        title: '提示',
        message: "格式错误，请填写数据的十六进制格式文本",
        type: 'warning'
      })
      isDisabled.value = false
      return
    }
    const res = type == 'Ptx' ? await Rpc.sendTransaction(str) : await Rpc.decodeRawTransaction(str)
    dealMsg(res)
    isDisabled.value = false
  }

  return { result, isDisabled, submit }
}